import Vue from 'vue'
import App from './workflow_stage/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const templateBuilder = document.getElementById('workflow-app');

  if (templateBuilder) {
    new Vue({
      el: '#workflow-app',
      render: h => h(App)
    }).$mount();
  }
});